/*global o_util*/

window.o_global = window.o_global || {};

o_global.device = o_global.device || {};

/**
 * Identify the used os based on the user-agent.
 * The user-agent can be easily manipulated! Use the information with caution.
 *
 * @return {String} Name of the operating system.
 */
o_global.device.os = (function(findInUserAgent) {
    "use strict";

    var windowsPlatformToken = {
            "Windows 98": "Windows 98",
            "Windows 98; Win 9x 4.90 ": "Windows Me",
            "Windows NT 4.0": "Microsoft Windows NT 4.0",
            "Windows NT 5.0": "Windows 2000",
            "Windows NT 5.01": "Windows 2000 SP1",
            "Windows NT 5.1": "Windows XP",
            "Windows NT 5.2": "Windows Server 2003; Windows XP x64 Edition",
            "Windows NT 6.0": "Windows Vista",
            "Windows NT 6.1": "Windows 7",
            "Windows NT 6.2": "Windows 8",
            "Windows NT 6.3": "Windows 8.1",
            "Windows NT 10.0": "Windows 10",
            "Windows NT 10.1": "Windows 10.1"
        },
        key;

    // Windows | http://msdn.microsoft.com/en-us/library/ms537503%28v=vs.85%29.aspx#PltToken
    for (key in windowsPlatformToken) {
        if (windowsPlatformToken.hasOwnProperty(key) && findInUserAgent(key.toLowerCase())) {
            return windowsPlatformToken[key];
        }
    }
    // BlackberryOS
    if (findInUserAgent("blackberry") || findInUserAgent("bb10") || findInUserAgent("rim") || findInUserAgent("playbook")) {
        return "Blackberry";
    }
    // FirefoxOS | https://developer.mozilla.org/de/docs/Gecko_user_agent_string_referenz
    if (findInUserAgent("(mobile;") || findInUserAgent("(tablet;")) {
        return "Firefox OS";
    }
    // HP webOS
    if (findInUserAgent("webos") || findInUserAgent("hpwos")) {
        return "HP webOS";
    }
    // Amazon FireOS | http://docs.aws.amazon.com/silk/latest/developerguide/user-agent.html
    if (findInUserAgent("silk") || findInUserAgent("kfot") || findInUserAgent("kftt") || findInUserAgent("kfjw") || findInUserAgent("kfsowi") || findInUserAgent("kfthw") || findInUserAgent("kfapw")) {
        return "Amazon FireOS";
    }
    // Symbian
    if (findInUserAgent("symbianos")) {
        return "Symbian";
    }
    // MacOS
    if (findInUserAgent("macintosh") && findInUserAgent("mac os x")) {
        return "Mac OS";
    }
    // Linux
    if (findInUserAgent("linux") && !findInUserAgent("android") && !findInUserAgent("webos")) {
        return "Linux";
    }
    // Windows Phone 10.0
    if (findInUserAgent("windows phone 10.0")) {
        return "Windows Phone 10.0";
    }
    // Windows Phone
    if (findInUserAgent("windows phone")) {
        return "Windows Phone";
    }
    // Android | https://developer.chrome.com/multidevice/user-agent
    if (findInUserAgent("android")) {
        return "Android";
    }
    // IOS
    if (findInUserAgent("iphone") || findInUserAgent("ipad") || findInUserAgent("ipod")) {
        return "iOS";
    }
    // Return operating system if not empty, "other" otherwise.
    return "other";
}(o_util.browser.findInUserAgent));
